import { useEffect, useMemo, useState } from "react";
import { Progress } from "../../../../components/Progress/Progress.tsx";
import { computeDateDifference } from "../../../../utils/date.ts";
import { IMAGE_RESOURCE_TYPE, VIDEO_RESOURCE_TYPE } from "../../constants.ts";
import type { Content } from "../../types.ts";

const MAX_GENERATION_LOADING_PROGRESS = 0.95;

export const ContentGenerationProgress = ({
  content,
}: {
  content: Content;
}) => {
  const estimatedGenerationTime = useMemo(() => {
    switch (content.resource_type) {
      case IMAGE_RESOURCE_TYPE:
        return 15;
      case VIDEO_RESOURCE_TYPE:
        return 40;
    }
  }, [content.resource_type]);

  const [secondsSinceCreation, setSecondsSinceCreation] = useState(0);
  // FIXME: We currently don't have the generation model type in the image object so we use default value for everyone

  useEffect(() => {
    const creationDate = new Date(content.created_at);
    const initialDifference = computeDateDifference(creationDate, new Date());
    setSecondsSinceCreation(initialDifference);

    // XXX: don't trigger a setInterval if generation is longer that estimated time because no progress will happen
    if (initialDifference < estimatedGenerationTime) {
      const intervalId = setInterval(() => {
        setSecondsSinceCreation(
          computeDateDifference(creationDate, new Date()),
        );
      }, 1000);
      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimatedGenerationTime]);

  return (
    <Progress
      value={Math.min(
        secondsSinceCreation / estimatedGenerationTime,
        MAX_GENERATION_LOADING_PROGRESS,
      )}
      rootClassName="!bg-surface-primary-hover rounded-200"
      indicatorClassName="animate-pulse"
    />
  );
};
